module.exports = __webpack_public_path__ + "img/8.cbd96f3c.png";